import * as Yup from 'yup'

import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

export function getUserEditTextFieldFormModalValidationSchema({
  fieldName,
  fieldRequired,
  initialValues,
}) {
  const noChangedSchema = formValidationSchemaNoChanged({ initialValues })

  return fieldRequired
    ? Yup.object({
        [fieldName]: Yup.string().ensure().required(true),
      }).concat(noChangedSchema)
    : noChangedSchema
}

export function getUserEditTextFieldFormModalInitialValues({
  fieldName,
  value,
  withActionType = true,
}) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...(withActionType
      ? {
          [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
            actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
        }
      : null),
    [fieldName]: value ?? FORMIK_EMPTY_VALUE,
  }
}
